<template>
    <div class="enquiry">
        <div class="enquiry_title">{{ $t('loginTitle') }}</div>
        <el-form class="enquiry_main demo-form-inline" ref="dataForm">
            <div v-if="$i18n.locale == 'english'" class="login-tabs">
                <span class="emailSpan" :class="{ active: tabsIndex === 1 }" @click="tabsIndex = 1"
                    >{{ $t('loginForm.emailLoginTitle') }} </span
                ><span class="mobileSpan" :class="{ active: tabsIndex === 0 }" @click="tabsIndex = 0">{{
                    $t('loginForm.phoneLoginTitle')
                }}</span>
            </div>
            <div v-else class="login-tabs">
                <span class="emailSpanCh" :class="{ active: tabsIndex === 1 }" @click="tabsIndex = 1"
                    >{{ $t('loginForm.emailLoginTitle') }} </span
                ><span class="mobileSpanCh" :class="{ active: tabsIndex === 0 }" @click="tabsIndex = 0">{{
                    $t('loginForm.phoneLoginTitle')
                }}</span>
            </div>
            <div v-show="tabsIndex === 0">
                <el-form-item :label="$t('intl_code')" class="enquiry_main_code">
                    <el-select
                        v-model="temp.code"
                        placeholder=""
                        :popper-append-to-body="false"
                        popper-class="optionsContents"
                    >
                        <el-option
                            v-for="(item, i) in areaCode"
                            :key="i"
                            :value="item.phone_code"
                            :label="' +' + item.phone_code"
                            >{{ $i18n.locale == 'chinese' ? item.chinese_name : item.english_name }} +{{
                                item.phone_code
                            }}</el-option
                        >
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('mobile_number')" class="enquiry_main_number">
                    <el-input v-model="temp.mobile"></el-input>
                </el-form-item>
                <el-form-item :label="$t('verification_code')" class="verification_code">
                    <el-input v-model="temp.verification_code" class="verification_input"></el-input>
                </el-form-item>
                <el-form-item class="getCodeItem">
                    <el-button class="getCodeBtn" @click="getCode" v-show="!codeFlag" :loading="mobileCodeLoading">{{
                        $t('get_verification_code')
                    }}</el-button>
                    <div class="getCodeBtn-Coded" v-show="codeFlag">{{ codeIndex }}s</div>
                </el-form-item>
                <el-button class="enquiry_sub" @click="login" :loading="mobileLoading">{{ $t('login') }}</el-button>
            </div>
            <div v-show="tabsIndex === 1">
                <el-form-item :label="$t('e_mail')" class="enquiry_main_email">
                    <el-input v-model="emailLoginData.email"></el-input>
                </el-form-item>
                <el-form-item :label="$t('verification_code')" class="verification_code">
                    <el-input v-model="emailLoginData.verification_code" class="verification_input"></el-input>
                </el-form-item>
                <el-form-item class="getCodeItem">
                    <el-button
                        class="getCodeBtn"
                        @click="getEmailCode"
                        v-show="!emailCodeIndex"
                        :loading="emailCodeLoading"
                        >{{ $t('get_verification_code') }}</el-button
                    >
                    <div class="getCodeBtn-Coded" v-show="emailCodeFlag">{{ emailCodeIndex }}s</div>
                </el-form-item>
                <el-button class="enquiry_sub" @click="emailLogin" :loading="emailLoading">{{ $t('login') }}</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { check_Number, checkAllNull, check_Mail, SortAreaCode } from '@/libs/form'
import AreaCode from '@/utils/phone.json'
export default {
    props: ['books', 'showLogin'],
    data() {
        return {
            areaCode: AreaCode.sort(SortAreaCode),
            temp: {
                code: '',
                mobile: '',
                verification_code: '',
            },
            emailLoginData: {
                verification_code: '',
                email: '',
            },
            codeIndex: 0,
            codeFlag: false,
            emailCodeIndex: 0,
            emailCodeFlag: false,
            time: null,
            emailTimer: null,
            tabsIndex: 1,
            mobileCodeLoading: false,
            emailCodeLoading: false,
            mobileLoading: false,
            emailLoading: false,
        }
    },
    methods: {
        /**
         * 手机号码登录
         */
        login() {
            let { code, mobile, verification_code } = this.temp
            if (!check_Number(code) || !checkAllNull(code) || !check_Number(mobile) || !checkAllNull(mobile)) {
                this.$message.warning(this.$t('form.phoneCheck'))
                return
            }
            if (code.length + mobile.length > 20 || code.length + mobile.length < 6) {
                this.$message.warning(this.$t('form.phoneCheck'))
                return
            }
            if (!check_Number(verification_code) || !checkAllNull(verification_code)) {
                this.$message.warning(this.$t('loginForm.verification_code'))
                return
            }
            let data = {
                mobile: code + '-' + mobile,
                smsCode: verification_code,
            }
            this.mobileLoading = true
            this.$store
                .dispatch('login/mobileLogin', data)
                .then(() => {
                    this.$emit('submit')
                    this.mobileLoading = false
                })
                .catch(() => {
                    this.mobileLoading = false
                })
        },
        /**
         * 邮箱登录
         */
        async emailLogin() {
            const { email, verification_code } = this.emailLoginData
            if (email === '' || !check_Mail(email)) {
                return this.$message.warning(this.$t('form.emailCheck'))
            }
            if (verification_code === '' || !check_Number(verification_code)) {
                return this.$message.warning(this.$t('loginForm.verification_code'))
            }
            this.emailLoading = true
            this.$store
                .dispatch('login/emailLogin', { email, emailCode: verification_code })
                .then(() => {
                    this.emailLoading = false
                    this.$emit('submit')
                })
                .catch(() => {
                    this.emailLoading = false
                })
        },
        /**
         * 获取手机验证码
         */
        getCode() {
            const { code, mobile } = this.temp
            if (code.length + mobile.length > 16 || code.length + mobile.length < 6 || !check_Number(code)) {
                this.$message.warning(this.$t('form.phoneCheck'))
                return
            }
            this.mobileCodeLoading = true
            this.$store
                .dispatch('login/getCodeSms', `${code}-${mobile}`)
                .then(() => {
                    this.codeIndex = 120
                    this.codeFlag = true
                    this.mobileCodeLoading = false
                    this.timer = setInterval(() => {
                        this.codeIndex--
                        if (this.codeIndex === 0) {
                            this.codeFlag = false
                            clearInterval(this.timer)
                        }
                    }, 1000)
                })
                .catch(() => {
                    this.mobileCodeLoading = false
                })
        },
        /**
         * 获取邮箱验证码
         */
        getEmailCode() {
            const { email } = this.emailLoginData
            if (email === '' || !check_Mail(email)) {
                return this.$message.warning(this.$t('form.emailCheck'))
            }
            this.emailCodeLoading = true
            this.$store
                .dispatch('login/getEmailCode', { email })
                .then(() => {
                    this.emailCodeIndex = 300
                    this.emailCodeFlag = true
                    this.emailCodeLoading = false
                    this.emailTimer = setInterval(() => {
                        this.emailCodeIndex--
                        if (this.emailCodeIndex === 0) {
                            this.emailCodeFlag = false
                            clearInterval(this.emailTimer)
                        }
                    }, 1000)
                })
                .catch(() => {
                    this.emailCodeLoading = false
                })
        },
    },
    mounted() {
        // console.log(this.showLogin)
    },
    watch: {
        showLogin() {
            if (!this.showLogin) {
                this.temp = {
                    code: '',
                    mobile: '',
                    verification_code: '',
                }
                this.emailLoginData = {
                    verification_code: '',
                    email: '',
                }
                this.emailCodeFlag = false
                this.codeFlag = false
                this.emailCodeIndex = 0
                this.codeIndex = 0
                clearInterval(this.emailTimer)
                clearInterval(this.time)
            }
        },
    },
}
</script>
<style scoped src="@/styles/super.css"></style>
<style lang="less" scoped>
.enquiry {
    .enquiry_title {
        width: 466px;
        height: 61px;
        background: linear-gradient(180deg, #172a88 0%, #0c1544 100%);
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
        border: 6px solid #ffffff;
        font-size: 18px;
        font-family: Lato-Bold, Lato;
        font-weight: bold;
        color: #ffffff;
        line-height: 48px;
        text-align: center;
    }
    .el-select {
        margin-top: 10px;
    }
}

/deep/.enquiry_main {
    width: 466px;
    /* height: 540px; */
    background: #ffffff;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
    padding: 24px 22px;
    box-sizing: border-box;
    flex-wrap: wrap;
    .el-input__inner {
        width: 423px;
        height: 26px;
        background: #f7f7f7;
        box-shadow: inset 0px 0px 1px 0px rgba(0, 0, 0, 0.16);
        border-radius: 5px;
        line-height: 26px;
    }
    .el-form-item__label {
        height: 19px;
        font-size: 14px;
        font-family: Lato-Bold, Lato;
        font-weight: bold;
        color: #172a88;
        line-height: 19px;
        margin-bottom: 9px;
        white-space: nowrap;
    }
    .enquiry_main_code {
        width: 80px;
        float: left;
    }
    .enquiry_sub {
        width: 423px;
        height: 31px;
        background: #172a88;
        box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
        margin-top: 6px;
        font-size: 12px;
        font-family: Lato-Bold, Lato;
        font-weight: bold;
        color: #ffffff;
        padding: 0;
    }
}
.enquiry_main {
    padding: 20px 22px 30px;
    height: 400px;
}
/deep/ .el-form-item {
    margin-bottom: 45px;
}
/deep/ .enquiry_main .enquiry_main_code .el-input__inner {
    // margin-top: 10px;
    width: 127px;
}
/deep/ .enquiry_main .enquiry_main_number {
    width: 286px;
    margin-left: 55px;
}
/deep/ .enquiry_main .enquiry_main_number .el-input__inner {
    margin-top: 10px;
    width: 286px;
}
/deep/ .el-select .el-input .el-select__caret.is-reverse {
    transform: rotateZ(0deg);
}
/deep/ .enquiry_main .verification_code .el-input__inner {
    width: 220px;
    // width: 60%;
}
.verification_input {
    margin-top: 10px;
    width: 220px;
}
.getCodeBtn {
    width: 188px;
    height: 26px;
    background-color: #172a88;
    border-radius: 6px;
    font-size: 14px;
    padding: 0;
    color: #fff;
    margin-top: 38px;
    margin-left: 8px;
}
.getCodeBtn-Coded {
    background-color: #ccc !important;
    width: 188px;
    height: 26px;
    border-radius: 6px;
    font-size: 14px;
    border: none;
    line-height: 26px;
    text-align: center;
    color: #fff;
    margin-top: 38px;
    margin-left: 8px;
}
.getCodeBtn-Coded:hover {
    background-color: #ccc !important;
}
.enquiry_main .enquiry_sub {
    margin-top: 20px;
}
/deep/.optionsContents .el-select-dropdown__list {
    width: 239px;
    height: 196px;
}
.login-tabs {
    font-family: SegoeUI-Bold;
    font-size: 16px;
    background-color: #fff;
    margin-bottom: 40px;
    color: #172a88;
    font-weight: bold;
    display: flex;
    span {
        display: block;
        line-height: 30px;
        cursor: pointer;
        position: relative;
    }
    .mobileSpan {
        padding: 0 10px;
    }
    .emailSpan {
        padding: 0 20px;
    }
    .mobileSpanCh {
        padding: 0 15px;
        font-size: 14px;
    }
    .emailSpanCh {
        padding: 0 20px;
        font-size: 14px;
    }
    .active {
        // border-bottom: 2px solid #172a88;
        height: 30px;
        background-color: #172a88;
        color: #fff;
        position: relative;
    }
    & > .active::after {
        content: '';
        position: absolute;
        bottom: -6px;
        right: 0;
        left: 0;
        margin: auto;
        width: 0;
        height: 0;
        border-top: 7px solid #172a88;
        border-right: 7px solid transparent;
        border-left: 7px solid transparent;
    }
    span:first-child {
        margin-right: 15px;
    }
}
.enquiry_main_email {
    width: 100%;
    /deep/.el-form-item__label {
        margin-bottom: 20px;
    }
}
/deep/.el-select-dropdown__item {
    font-family: 'Lato Bold Italic' !important;
}
</style>
